<template>
  <gl-page icon-name="gr-team" title="Holders">
    <holders-table />
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'
import HoldersTable from '@/components/Holders/HoldersTable'

export default {
  name: 'Holders',
  components: { HoldersTable, GlPage },
}
</script>
